import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import initializeStore from "apps/messenger/store";
import {
	openConversation,
	closeConversation,
} from "ducks/global_messaging";

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			openConversation,
			closeConversation,
		},
		dispatch,
	);
};

// HoC to pass messenger action creators down to other components.
export default function withMessenger(Component) {
	const store = initializeStore();
	const ConnectedWrappedComponent = connect(
		undefined,
		mapDispatchToProps,
	)(Component);

	return (props) => (
		<ConnectedWrappedComponent {...props} store={store} />
	);
}



// WEBPACK FOOTER //
// ./src/apps/messenger/containers/withMessenger.js